import { render, staticRenderFns } from "./prdOrcamentoItemModal.vue?vue&type=template&id=10f5f792&scoped=true&"
import script from "./prdOrcamentoItemModal.vue?vue&type=script&lang=js&"
export * from "./prdOrcamentoItemModal.vue?vue&type=script&lang=js&"
import style0 from "./prdOrcamentoItemModal.vue?vue&type=style&index=0&id=10f5f792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5f792",
  null
  
)

export default component.exports